import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getSocket } from '../socket';
import { playSound } from '../utils/soundAlerts';

// ── 일정알림 실시간 알림 모달 ────────────────────────────────────────
// 일정관리(Schedules.js)의 등록/수정 모달에서 "🔔 일정알림"을 누르면(backend/routes/schedules.js
// POST /:id/notify가 대상자를 계산해 'schedule:notify' 이벤트를 내 개인 소켓 room(user:<아이디>)
// 으로 쏴준다), 지금 어느 화면을 보고 있든 TaskRequestAlert.js와 동일한 방식으로 바로 모달로
// 알려준다. 확인을 누르면 그냥 닫힐 뿐 별도 서버 기록은 필요 없다(요청/응답 워크플로우가 있는
// 업무요청과 달리, 일정알림은 "알려주면 끝"인 1회성 브로드캐스트라 seen 상태를 추적하지 않음).
// 상태표시줄 반영은 서버 쪽에서 이 알림을 보낼 때 logActivity를 함께 호출해서 처리한다.
export default function ScheduleNotifyAlert() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [incoming, setIncoming] = useState(null);

  useEffect(() => {
    if (!user) return;
    const socket = getSocket();
    if (!socket) return;

    const onNotify = (payload) => {
      if (document.fullscreenElement) return; // 생산전광판 전체화면 중에는 방해하지 않음
      setIncoming(payload);
      playSound('task');
    };
    socket.on('schedule:notify', onNotify);
    return () => socket.off('schedule:notify', onNotify);
  }, [user]);

  if (!incoming) return null;

  const goToSchedules = () => {
    setIncoming(null);
    navigate('/schedules');
  };

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:3000,
      display:'flex', alignItems:'center', justifyContent:'center' }}
      onClick={() => setIncoming(null)}>
      <div style={{ background:'#fff', borderRadius:14, width:420, maxWidth:'90vw', padding:'26px 24px 22px' }}
        onClick={e => e.stopPropagation()}>
        <div style={{ fontSize:12.5, fontWeight:700, color:'#185FA5', marginBottom:8 }}>
          🔔 일정알림{incoming.mode === 'attendees' ? ' (참석자)' : ''}
        </div>
        <div style={{ fontSize:16.5, fontWeight:700, color:'#1a1a1a', marginBottom:8 }}>{incoming.title}</div>
        <div style={{ fontSize:13, color:'#666', marginBottom:4 }}>
          {incoming.start_date}{incoming.start_time ? ` ${incoming.start_time}` : ''}{incoming.location ? ` · ${incoming.location}` : ''}
        </div>
        <div style={{ fontSize:13, color:'#666', marginBottom:4 }}>알림 발신자 {incoming.by}</div>
        {incoming.content && (
          <div style={{ marginTop:10, padding:'10px 12px', background:'#f8fafc', borderRadius:8,
            fontSize:13, color:'#333', whiteSpace:'pre-wrap', lineHeight:1.6, maxHeight:120, overflowY:'auto' }}>
            {incoming.content}
          </div>
        )}
        <div style={{ display:'flex', gap:8, marginTop:20 }}>
          <button onClick={goToSchedules}
            style={{ flex:1, padding:'11px', background:'#185FA5', color:'#fff', border:'none',
              borderRadius:8, fontSize:13, fontWeight:700, cursor:'pointer' }}>
            일정관리로 이동
          </button>
          <button onClick={() => setIncoming(null)}
            style={{ flex:1, padding:'11px', background:'#fff', color:'#555', border:'1px solid #ddd',
              borderRadius:8, fontSize:13, fontWeight:600, cursor:'pointer' }}>
            확인
          </button>
        </div>
      </div>
    </div>
  );
}
